import type { MessageSeverity } from "@mdotm/shadcn/legacy/components";
import type { BannerItem } from "./types";

const severityRank: Record<MessageSeverity, number> = { error: 0, warning: 1, info: 2, success: 3 };

/** Undated banners sort after dated ones. */
function compareCreatedAt(a: number | undefined, b: number | undefined): number {
	if (a === b) {
		return 0;
	}
	if (a == null) {
		return 1;
	}
	if (b == null) {
		return -1;
	}
	return a - b;
}

/**
 * Most severe first: error, warning, info, success. Within a severity, oldest `createdAt` first, then
 * the order they were given in (`sort` is stable).
 */
export function sortBanners(banners: readonly BannerItem[]): BannerItem[] {
	return [...banners].sort(
		(a, b) => severityRank[a.severity] - severityRank[b.severity] || compareCreatedAt(a.createdAt, b.createdAt),
	);
}
